import type {
  PersistedStateOptions,
} from '@packages/persiststate/types/store-persist.ts'

function isObject (v: unknown) {
  return typeof v === 'object' && v !== null
}

export function normalizeOptions (
  options: boolean | PersistedStateOptions | undefined
): PersistedStateOptions {
  options = isObject(options) ? options : Object.create(null)

  return new Proxy(options as object, {
    get (target, key, receiver) {
      if (key === 'key') {
        return Reflect.get(target, key, receiver)
      }

      return (
        Reflect.get(target, key, receiver)
      )
    },
  })
}
